(() => {
  const current = new URL(location.href);
  const root = window.Shopify?.routes?.root || '/';
  const searchPath = `${root}search`;
  function interpret(raw) {
    const original = raw.trim();
    let text = original.toLowerCase().replace(/gold[- ]filled/g, 'gold fill').replace(/gold-fill/g, 'gold fill');
    const budget = text.match(/\b(under|below|less than|up to)\s*\$?\s*(\d+(?:\.\d{1,2})?)/);
    let ceiling = null;
    if (budget) {
      ceiling = Math.max(0, Number(budget[2]) - (budget[1] === 'up to' ? 0 : 0.01)).toFixed(2);
      text = text.replace(budget[0], '').replace(/\b(gifts?|presents?|for|her|him|mom|mum|mother|wife|friend|teacher|a|the|jewelry|jewellery)\b/g, ' ').trim();
    }
    if (/\btitle:/.test(text)) return {query: original, ceiling};
    const stems = {hoops:'hoop*',hoop:'hoop*',necklaces:'necklace*',necklace:'necklace*',earrings:'earring*',earring:'earring*',rings:'ring*',ring:'ring*',studs:'stud*',stud:'stud*',pendants:'pendant*',pendant:'pendant*',bracelets:'bracelet*',bracelet:'bracelet*',threaders:'threader*',threader:'threader*',pearls:'pearl*',pearl:'pearl*',diamonds:'diamond*',diamond:'diamond*'};
    const metals = new Set(['gold','fill','sterling','silver','solid','vermeil','14k']);
    const words = text.split(/\s+/).filter(Boolean);
    const constrained = words.some(word => stems[word] || metals.has(word));
    const query = constrained ? words.map(word => stems[word] ? `title:${stems[word]}` : metals.has(word) ? `title:${word}` : word).join(' AND ') : text;
    return {query: query || '*', ceiling};
  }
  function destination(raw, base = new URL(searchPath, location.origin)) {
    const parsed = interpret(raw);
    base.searchParams.set('q', parsed.query);
    base.searchParams.set('type', 'product');
    base.searchParams.set('options[unavailable_products]', 'hide');
    base.searchParams.set('smj_term', raw.trim());
    base.searchParams.delete('page');
    if (parsed.ceiling !== null) {
      base.searchParams.set('filter.v.price.lte', parsed.ceiling);
      base.searchParams.set('filter.v.availability', '1');
    }
    return base;
  }
  function presentTerms() {
    const url = new URL(location.href);
    if (url.pathname !== searchPath) return;
    const term = url.searchParams.get('smj_term');
    if (!term) return;
    document.querySelectorAll('form.search-form input[name="q"]').forEach(input => { input.value = term; });
    const caption = document.querySelector('.search__caption');
    if (caption) caption.textContent = caption.textContent.replace(/"[^"]*"/, () => `"${term}"`);
  }
  if (current.pathname === searchPath && current.searchParams.has('q')) {
    const raw = current.searchParams.get('q');
    const normalized = destination(raw, new URL(current));
    normalized.searchParams.set('smj_term', current.searchParams.get('smj_term') || raw);
    if (normalized.searchParams.get('q') !== raw || current.searchParams.get('type') !== 'product' || current.searchParams.get('options[unavailable_products]') !== 'hide') {
      location.replace(normalized.href);
      return;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.search-form')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input?.value.trim()) return;
    const selectedLink = form.querySelector('[aria-selected="true"] a');
    if (selectedLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination(input.value).href);
  }, true);
  presentTerms();
  customElements.whenDefined('predictive-search').then(() => {
    const Search = customElements.get('predictive-search');
    Search.prototype.getSearchResults = async function (term) {
      const requestId = this.smjRequestId = (this.smjRequestId || 0) + 1;
      this.setLiveRegionLoadingState();
      try {
        const url = destination(term);
        url.searchParams.set('section_id', 'smj-search-suggestions');
        const response = await fetch(url, {signal:this.abortController.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = doc.querySelector('#predictive-search-results');
        if (!result) throw new Error('Search unavailable');
        if (requestId !== this.smjRequestId || this.getQuery() !== term) return;
        result.querySelectorAll('[role="option"]').forEach((option, index) => { option.id = `smj-search-option-${index}`; });
        this.renderSearchResults(result.outerHTML);
      } catch (error) {
        if (requestId !== this.smjRequestId || error.name === 'AbortError') return;
        this.close();
      }
    };
  });
})();
